import { Theme, createStyles, makeStyles } from '../../../../UI'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      height: '100%',
      gridAutoRows: 'min-content min-content auto'
    },
    progressBox: {
      width: '100%',
      maxWidth: '315px',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '360px'
      }
    },
    progress: {
      background: 'rgba(39, 186, 45, 0.08)',
      height: 6,
      borderRadius: 4
    },
    header: {
      display: 'grid',
      gap: '16px',
      width: '100%',
      padding: '16px 0',
      gridAutoFlow: 'column',
      gridAutoColumns: 'auto min-content'
    },
    headerColumn: {
      display: 'flex',
      gap: '16px',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    address: {
      color: 'var(--input-color)',
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      fontWeight: 900,
      fontSize: '28px',
      lineHeight: '150%',
      paddingLeft: "50px",
      [theme.breakpoints.down('lg')]: {
        // fontSize: '28px'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.875rem',
        paddingLeft: '8px'
      }
    },
    headerRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '16px',
      '& p': {
        fontFamily: 'BetterSansRegular'
      },
      alignItems: 'center'
    },
    headerItem: {
      display: 'flex',
      gap: '4px',
      flexDirection: 'row'
    },
    headerTextBold: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 700
    },
    headerText: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 400
    },
    estimateBox: {
      display: 'flex',
      gap: '16px',
      flexDirection: 'row',
      color: 'var(--better-color)'
    },
    estimateText: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 500,
      background: 'var(--better-light-color)',
      borderRadius: '16px',
      padding: '8px 16px',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 2px rgba(26, 42, 85, 0.31)'
    },
    icon: {
      width: '24px',
      height: '24px'
    },
    dot: {
      width: '4px',
      height: '4px',
      borderRadius: '25px',
      alignSelf: 'center',
      background: 'var(--better-color)'
    },
    combo: {
      height: '33px',
      width: '104px',
      minWidth: '100px',
      textTransform: 'none',
      borderRadius: '8px',
      backgroundColor: 'var(--row-background)',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 2px rgba(26, 42, 85, 0.31)',
      '&:hover': {
        backgroundColor: 'var(--row-background)',
        boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 1px 0px 2px rgba(26, 42, 85, 0.31), 0px 1px 3px rgba(26, 42, 85, 0.31)'
      },
      '& .MuiButton-label': {
        paddingTop: 0
      }
    },
    comboSelected: {
      height: '33px',
      width: '104px',
      minWidth: '100px',
      textTransform: 'none',
      borderRadius: '8px',
      color: 'var(--white-color)',
      backgroundColor: 'var(--better-color)',
      boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 0px 2px rgba(26, 42, 85, 0.31)',
      '&:hover': {
        backgroundColor: 'var(--better-color)',
        boxShadow: '0px 1px 1px rgba(26, 42, 85, 0.24), 0px 1px 2px rgba(26, 42, 85, 0.31), -1px 1px 2px rgba(26, 42, 85, 0.31)'
      },
      '& .MuiButton-label': {
        paddingTop: 0
      }
    },
    iconCombo: {
      color: 'var(--head-text-color)'
    },
    iconSelected: {
      color: 'var(--white-color)'
    },
    subtitle: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 400,
      lineHeight: '24px',
      fontSize: '16px',
      margin: '0px 0px 0px 0px',
      color: 'var(--head-text-color)'
    },
    subtitleSelected: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 400,
      lineHeight: '24px',
      fontSize: '16px',
      margin: '0px 0px 0px 0px',
      color: 'var(--white-color)'
    },
    estimateButton: {
      display: 'flex',
      justifyContent: 'center',
      gap: '8px',
      marginLeft: '16px',
      alignItems: 'center',
      cursor: 'pointer',
      flexDirection: 'column',
      backgroundColor: 'rgba(249, 250, 250, 1)',
      padding: '8px 8px 4px',
      borderRadius: '8px'
    },
    logo: {
      width: '190px'
    },
    title: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px',
      flexWrap: 'wrap',
      height: '80px',
      alignItems: 'center',
      paddingLeft: '50px',
      [theme.breakpoints.down('lg')]: {
        paddingLeft: '70px',
        fontSize: '24px'
      }
    },
    titleContainer: {},
    addressBox: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    description: {
      color: 'var(--input-color)'
    },
    text: {
      fontFamily: 'BetterSansRegular',
      fontWeight: 700,
      borderRadius: '8px',
      padding: '6px 16px 4px',
      color: 'var(--bosscat-blue-600)',
      backgroundColor: 'rgba(250, 251, 255, 1)',
      textAlign: 'center'
    },
    total: {
      fontSize: '18px',
      backgroundColor: 'var(--background-color-secondary)',
      textAlign: 'center',
      padding: '8px'
    },
    button: {
      width: '220px',
      height: '56px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-green-600)',
      borderRadius: 8,
      margin: '5px',
      endIcon: {
        width: '5px',
        height: '5px'
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '40px'
      },
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700)'
      }
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '2rem'
    },
    downloadButtonMobile: {
      height: '100% !important'
    },
    totalPrice: {
      fontFamily: 'OutfitBold',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '150%',
      color: 'var(--input-text)'
    }
  })
)
